export interface IValidationStart {
    hasEmail: boolean,
    coordinatorContactId: boolean,
    email: boolean,
    emailNotDuplicate: boolean
}

export interface IValidationConfirmMatch {
    selectedItem: boolean
}

export interface IValidationDetails {
    email: boolean,
    phone: boolean,
    country: boolean,
    firstName: boolean,
    lastName: boolean,
    addressLine1: boolean,
    city: boolean,
    state: boolean,
    nonUsStateProvince: boolean,
    postalCode: boolean,
    gender: boolean,
    birthDate: boolean,
    donationDate: boolean,
    heightSubFeet: boolean,
    // heightSubInches: boolean,
    weightLbs: boolean
}